/* fourpaw-standard: lifecycle-delegated */
(() => {
  if (window.SafeWalkV8GiftPackRepair) return;

  const metadataFor = (item) => {
    const raw = item?.properties?.__kaching_bundles;
    if (!raw) return null;
    if (typeof raw === 'object') return raw;
    try {
      const parsed = JSON.parse(raw);
      return parsed && typeof parsed === 'object' ? parsed : null;
    } catch (_) {
      return null;
    }
  };
  const safeDuplicateGroup = (group) => {
    const gifts = Array.isArray(group?.gifts) ? group.gifts : [];
    if (gifts.length < 2 || !group.main?.quantity) return false;
    const first = gifts[0];
    const firstMetadata = metadataFor(first);
    return gifts.every((gift) => {
      const metadata = metadataFor(gift);
      const firstVariant = Number(first.variant_id || first.id || 0);
      const giftVariant = Number(gift.variant_id || gift.id || 0);
      return Number(gift.product_id) === Number(first.product_id)
        && ((firstVariant === 0 && giftVariant === 0) || firstVariant === giftVariant)
        && Number(gift.final_line_price || 0) === 0
        && metadata?.deal === firstMetadata?.deal
        && String(metadata?.id || '') === String(firstMetadata?.id || '')
        && String(metadata?.gift || '') === String(firstMetadata?.gift || '')
        && String(gift.parent_relationship?.parent_key || gift.parent_relationship?.parent?.key || '')
          === String(first.parent_relationship?.parent_key || first.parent_relationship?.parent?.key || '');
    });
  };

  const plan = (state) => {
    const updates = {};
    const seen = new Set();
    for (const group of state?.groups || []) {
      if (!safeDuplicateGroup(group)) continue;
      const keys = group.gifts.map((gift) => String(gift.key || '')).filter(Boolean);
      if (keys.some((key) => seen.has(key))) return null;
      keys.forEach((key) => seen.add(key));
      updates[keys[0]] = Number(group.main.quantity);
      keys.slice(1).forEach((key) => { updates[key] = 0; });
    }
    return Object.keys(updates).length ? { updates, removed: Math.max(0, Object.keys(updates).length - (state?.groups || []).filter(safeDuplicateGroup).length) } : null;
  };

  window.SafeWalkV8GiftPackRepair = Object.freeze({ plan });
})();
